module.exports = __webpack_public_path__ + "static/media/API_Image_MMS_Thumb@2x.f2812024.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/guides/Introduction/API_Image_MMS_Thumb@2x.png
// module id = 1321
// module chunks = 0